import React from "react";
import SectionHeader from "../components/SectionHeader";

const FounderNextChapterSection = ({ data }) => {
    //console.log("FOUNDER NEXT CHAPTER DATA:", data);

    return (
        <section className="founder-journey">

            <div className="container">

                {/* =================================================
                     HEADER
                ================================================== */}

                <SectionHeader
                    eyebrow={data.eyebrow}
                    title={data.title}
                    highlight={data.highlight}
                />

                {/* =================================================
                     NEXT CHAPTER CONTENT
                ================================================== */}

                <div className="journey-current">

                    {(data.paragraphs || []).map(
                        (paragraph, i) => (
                            <p key={i}>
                                {paragraph}
                            </p>
                        )
                    )}

                </div>

            </div>

        </section>
    );
};

export default FounderNextChapterSection;